module.exports = __webpack_public_path__ + "images/Genre.a9121fed587e7c754508c2f40de2112c.svg";